export const PRICING_WS_TIMEOUT_MS = 10_000;
export const PRICING_FALLBACK_COOLDOWN_MS = 30_000;
export const PRICING_RECOVERY_CHECK_INTERVAL_MS = 10_000;
export const PRICING_TAB_INACTIVE_DISCONNECT_DELAY_MS = 5000;
